import Departamentos from '@/components/ADepartamentos.vue'
import Ciudades from '@/components/ACiudades.vue'
import Universidades from '@/components/AUniversidades.vue'
import Profesiones from '@/components/AProfesiones.vue'
import Grados from '@/components/AGrados.vue'
import Usuarios from '@/components/AUsuariosActivos.vue'
import Empresas from '@/components/AEmpresas.vue'
import BuscarEstudiante from '@/components/ABuscarEstudiante.vue'
import Alertas from '@/components/AAlertas.vue'
import RegistroEstudiante from '@/components/ARegEstudiante.vue'
import Fecha from '@/components/AFecha.vue'
import PlanPagos from '@/components/AVer-cuotas.vue'
import PagarMatricula from '@/components/APagar-matricula.vue'
import PagarCuota from '@/components/APagar-cuota.vue'
import {generarContrato} from '@/components/generar-contrato.js'
import { Validator } from 'simple-vue-validator'
import gql from 'graphql-tag'
import {parseJsonError,datFaltantes,isNullObject,error} from '@/components/Utils.js'

export default {
    data(){
        return {
            activo: true,
            preinscribir: true,
            datosvalidos: true,
            msg: '',
            modelinscrito:{},
            idNewInscripcion: 0,
            programa: {},
            cuotas_validas: { valido:true },
            atras:'programas',
            newEstudiante: {
                iddepartamento: null,
                idciudad: null,
                idprofesion: null,
                iduniversidad: null,
                idempresa: null,
                idgrado: null,
            },
            inscripcion:{
                idestudiante: null,
                tipopago: false,
                idprograma: null,
                idusuario: null,
                matricula:{ monto:-1,fecha:"" },
                certificacion:{ monto:-1,fecha:"" },
                monto:{monto_colegiatura:-1,cuotas:null,fecha_ins:null,},
                observaciones: null,
            },
            matriculaCreada:{id:-1},
            cuotas_por_pagar:[],
            cuotas:[],
            inscripcionrest: {
                "programa_id": null,
                "estudiante_id": null,
                "asesor_id": null,
                "registrado_por": 1,
                "tipo_pago": true,
                "plan_pagos": [
                    {
                        "cobro_programa_id": 5,
                        "monto": 300,
                        "nro_cuota": 0
                    }
                
                ]
            }
        }
    },
    components:{ 
        Departamentos,Ciudades,Universidades,Profesiones,Grados,Usuarios,
        Empresas,BuscarEstudiante,Alertas,RegistroEstudiante,Fecha,PlanPagos,
        PagarMatricula,PagarCuota
    },
    validators: {
        'inscripcion.idprograma'(value){ return Validator.value(value).required(); },
        'inscripcion.idestudiante'(value){ return Validator.value(value).required(); },
        'inscripcion.idusuario'(value){ return Validator.value(value).required(); },
        'inscripcion.tipopago'(value){ return Validator.value(value).required(); },
        'inscripcion.matricula.monto'(value){ return Validator.value(value).required().digit(); },
        'inscripcion.monto.monto_colegiatura'(value){ return Validator.value(value).required().digit(); },
        'inscripcion.certificacion.monto'(value){ return Validator.value(value).required().digit(); },
        'inscripcion.monto.cuotas'(value){ return Validator.value(value).digit().greaterThan(0); },
        'inscripcion.observaciones'(value){ return Validator.value(value).minLength(0).regex("^[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+(\\s[A-ZÁÉÍÓÚÑa-zñáéíóú][A-ZÁÉÍÓÚÑa-zñáéíóú]+)*$"); },
    },
    watch:{
        'inscripcion.monto.cuotas': function(){
            this.lisCuotas();
        },
        inscripcion:{
            deep: true,
            handler(a){
                if(a==null) return;
                this.preinscribir = true;
                this.msg = '';
                this.$refs.alertar.reset();
                this.datosvalidos = false;
                window.sessionStorage.setItem( 'xinscripcion',JSON.stringify(this.inscripcion) );
                /*if( this.programa && this.inscripcion.matricula ){
                    if( this.inscripcion.matricula.monto == this.programa.monto_matricula ) this.inscripcion.tipopago = false;
                    else this.inscripcion.tipopago = true;
                }*/
                this.lisCuotas();
                
                if( a.monto.monto_colegiatura != null && a.monto.cuotas != null ){
                    var mensualidad = Math.trunc( Math.ceil(a.monto.monto_colegiatura / a.monto.cuotas) );
                    if( !isNaN(mensualidad) && isFinite(mensualidad) ){
                        var cole = parseInt(a.monto.monto_colegiatura);
                        var cuos = [];
                        var nro = 1;
                        var fecha = new Date();
                        var srtf = "";
                        while( cole-mensualidad > 0 ){
                            var ani = fecha.getFullYear();
                            var mes = fecha.getMonth()+1;
                            var dia = fecha.getDate();
                            if( mes < 10 ) mes = '0'+mes;
                            if( dia < 10 ) dia = '0'+dia;
                            cole = cole - mensualidad;
                            srtf = ani+"-"+mes+"-"+dia;
                            fecha.setMonth( mes );
                            fecha.setDate( 15 );
                            cuos.push( {monto:mensualidad,nro_cuota:nro,fecha:srtf} );
                            nro += 1;
                        }
                        if(cole>0){
                            ani = fecha.getFullYear();
                            mes = fecha.getMonth()+1;
                            dia = fecha.getDate();
                            if( mes < 10 ) mes = '0'+mes;
                            if( dia < 10 ) dia = '0'+dia;
                            srtf = ani+"-"+mes+"-"+dia;
                            fecha.setMonth( mes );
                            fecha.setDate( 15 );
                            cuos.push( {monto:cole,nro_cuota:nro,fecha:srtf} );
                        }
                        this.cuotas = cuos;
                        window.sessionStorage.setItem( "xcuotas",JSON.stringify(this.cuotas) );
                        this.preinscribir = false;
                    }
                }
            }
        }
    },
    methods:{
        lisCuotas(){
            if( this.inscripcion.monto.cuotas > 2 ) this.inscripcion.tipopago = true;
            else this.inscripcion.tipopago = false;
            window.console.log( "   ",this.inscripcion.tipopago );
        },
        xgenerarContrato(){
            if( this.inscripcion.idestudiante == null ){
                this.$notify( error( 'Contrato','Seleccione un Estudiante.' ) );
                return;
            }
            var obj = window.Object.assign({},this.inscripcion);
            obj.matricula.saldo = obj.matricula.monto;
            generarContrato( this.programa,this.cuotas,this.inscripcion.idestudiante,{monto_colegiatura:obj.monto.monto_colegiatura,monto_matricula:obj.matricula.monto},obj )
        },
        getNomBtn(){
            if( this.preinscribir ) return "Preinscribir";
            return "Inscribir";
        },
        getNomProgram(){
            if( this.programa == null ) return "";
            if( this.programa.postgrado == null ) return "";
            //return this.programa.postgrado.categoria.nombre +" - "+ this.programa.postgrado.nombre;
            return this.programa.nombre_compuesto;
        },
        validarCampos(){
            if( !this.activo ) return;
            this.activo = true;
            var vue = this;
            this.$validate().then((success) => {
                var obj = window.Object.assign({},this.inscripcion);
                if (success) {
                    vue.datosvalidos = true;
                    obj.idestudiante = obj.idestudiante.id;
                    obj.idasesor = obj.idusuario.id;
                    obj.matricula.monto = parseInt( obj.matricula.monto );
                    obj.certificacion.monto = parseInt( obj.certificacion.monto );
                    obj.monto.monto_colegiatura = parseInt( obj.monto.monto_colegiatura );
                    if( obj.tipopago || obj.tipopago == "true" ) obj.tipopago = true;
                    else obj.tipopago = false;

                    if( obj.matricula.monto > vue.programa.monto_matricula ){
                        vue.$notify( error( 'Matricula','La matricula no puede ser mayor a la establecida en el programa.' ) );
                        return;
                    }

                    delete obj.idusuario;
                    this.$store.state.obj = obj;
                    this.$store.dispatch('quitarNulos');
                    this.$refs.alertar.cargando();
                    delete obj.monto;
                    if( this.preinscribir ){
                        obj.monto_matricula = this.inscripcion.matricula.monto;
                        obj.monto_colegiatura = this.inscripcion.monto.monto_colegiatura;
                        obj.monto_certificacion = this.inscripcion.certificacion.monto;
                        delete obj.matricula;
                        delete obj.certificacion;
                        delete obj.tipopago;
                        window.sessionStorage.setItem('obj',JSON.stringify(obj))
                        this.$dialog.confirm(this.$store.state.alertmsg).then(function() { vue.xpreinscribir( obj )
                        }).catch(function() { vue.$refs.alertar.reset(); });
                    }else{
                        obj.cuotas = this.cuotas;
                        if( obj.matricula.fecha == "" || obj.certificacion.fecha == "" ){
                            this.$refs.alertar.invalido();
                            this.$notify( datFaltantes( "ERROR: ingrese las fechas de pago de matricula y certificacion" ) )
                        }else{
                            delete obj.matricula.saldo;
                            window.sessionStorage.setItem('obj',JSON.stringify(obj))
                            window.sessionStorage.setItem('objestudiante',JSON.stringify(obj.idestudiante))
                            this.$dialog.confirm(this.$store.state.alertmsg).then(function() { vue.inscribir( obj )
                            }).catch(function() { vue.$refs.alertar.reset(); });
                        }
                    }
                }else{
                    vue.datosvalidos = false;
                    this.$refs.alertar.invalido();
                }
            });
        },
        confirmado(){
            
        },
        xpreinscribir( obj ){
            obj = JSON.parse( window.sessionStorage.getItem('obj') );
            //window.console.log( "preinscribir" );
            var vue = this;
            var sql = gql`mutation{ createPreInscripcion(input:${window.stringifyObject(obj)}){ok,errors{message},inscripcion{matricula{id,monto,idinscripcion,puede_pagar,saldo}}} }`;
            vue.msg = '';
            window.console.log( sql );

            this.$apollo.mutate({
                mutation: sql,
            }).then((data) => {
                if(data.data.createPreInscripcion.ok){
                    vue.$refs.alertar.success();
                    window.sessionStorage.setItem( 'xprograma',null );
                    window.sessionStorage.setItem( 'xinscripcion',null );
                    window.firebaseNotificacion( "Nuevo Participante" );
                }else{
                    var errores = JSON.stringify(data.data.createPreInscripcion.errors);
                    var obj = JSON.parse( errores );
                    var vals = '';
                    obj.forEach(function(k){ vals += Object.values(k)+"-\n\t"; });
                    //vue.msg = vals;
                    vue.msg = '';
                    vue.activo = true;
                    vue.$refs.alertar.invalido( vals );
                }
                
                //window.console.log(data);
            }).catch((error) => {
                vue.$refs.alertar.invalido();
                this.activo = true;
                window.console.error(JSON.stringify(error));
                //vue.msg = error;
                
                this.$notify( parseJsonError( error ) )
            })
        },
        inscribir( obj ){
            //window.console.log( "inscribir" );
            obj = JSON.parse( window.sessionStorage.getItem('obj') );
            var vue = this;
            var sql = gql`mutation{ createInscripcion(input:${window.stringifyObject(obj)}){ ok,errors{message},inscripcion{id,asesor{nombres,pri_apellido,seg_apellido},estudiante{id,nombres,telefono1,pri_apellido,seg_apellido,num_doc,departamento{extension}},cuotas_por_pagar{id,monto,nro_cuota,saldo,fecha,puede_pagar}},inscripcion{matricula{id,monto,idinscripcion,puede_pagar,saldo}}} }`;
            vue.msg = '';
            window.console.log( sql );

            this.$apollo.mutate({
                mutation: sql,
            }).then((data) => {
                if(data.data.createInscripcion.ok){
                    vue.$refs.alertar.success();
                    window.sessionStorage.setItem( 'nueva_inscripcion',JSON.stringify(data.data.createInscripcion.inscripcion) )
                    vue.matriculaCreada = data.data.createInscripcion.inscripcion.matricula;
                    vue.cuotas_por_pagar = data.data.createInscripcion.inscripcion.cuotas_por_pagar;
                    vue.idNewInscripcion = data.data.createInscripcion.inscripcion.id;
                    window.sessionStorage.setItem( 'xprograma',null );
                    window.sessionStorage.setItem( 'xinscripcion',null );
                    var postg = '';
                    try{
                        postg = 'a: '+this.programa.postgrado.nombre;
                    }catch(e){window.console.log(e); }

                    window.firebaseNotificacion( "Nuevo Participante inscrito "+postg );
                }else{
                    var errores = JSON.stringify(data.data.createInscripcion.errors);
                    var obj = JSON.parse( errores );
                    var vals = '';
                    obj.forEach(function(k){ vals += Object.values(k)+"-\n\t"; });
                    //vue.msg = vals;
                    vue.msg = '';
                    vue.activo = true;
                    vue.$refs.alertar.invalido( vals );
                }
                 
                //window.console.log(data);
            }).catch((error) => {
                vue.$refs.alertar.invalido();
                this.activo = true;
                window.console.error(error);
                //vue.msg = error;
                this.$notify( parseJsonError( error ) )
            })
        },
        preEliminarInscripcion(){
            var vue = this;
            this.$dialog
            .confirm( "Confirmacion<br><br>Esta accion es irreersible, solo se puede eliminar una inscripcion cuando no haya cancelado ningun pago.<br><small>ID: "+this.idNewInscripcion+";"+this.programa.id+"</small>" )
            .then(function() {
                vue.eliminarInscripcion();
            }).catch(function(e) { window.console.error( e ) });
        },
        eliminarInscripcion(){
            var vue = this;
            this.$refs.alertar.cargando("Eliminando inscripcion...");
            var sql = gql`mutation{ deleteInscripcion(input:{ id:${this.idNewInscripcion},idprograma: ${this.programa.id} }){ok,errors{message}} }`;
            this.idNewInscripcion = 0;

            window.console.log( sql )

            this.$apollo.mutate({
                mutation: sql,
            }).then((data) => {
                if(data.data.deleteInscripcion.ok){
                    vue.$refs.alertar.success( "Inscripcion eliminada." );
                    vue.idNewInscripcion = 0;
                    vue.matriculaCreada.id = 0;
                }else{
                    var errores = JSON.stringify(data.data.deleteInscripcion.errors);
                    var obj = JSON.parse( errores );
                    var vals = '';
                    obj.forEach(function(k){ vals += Object.values(k)+"-\n\t"; });
                    vue.msg = '';
                    vue.activo = true;
                    vue.$refs.alertar.invalido( vals );
                }
            }).catch((error) => {
                this.activo = true;
                window.console.error(error);
                vue.msg = error;
                vue.$refs.alertar.invalido();
            })
        },
        validardatosrest(){
            this.msg = '';
            let userid = this.$store.state.DATA_USER.id;

            if( !this.inscripcion.idestudiante ){ this.msg = 'Seleccione un estudiante'; return }
            if( !this.inscripcion.idusuario ){ this.msg = 'Seleccione un asesor'; return }

            this.inscripcionrest.programa_id = this.programa.id;
            this.inscripcionrest.estudiante_id = this.inscripcion.idestudiante.id;
            this.inscripcionrest.asesor_id = this.inscripcion.idusuario.id;
            this.inscripcionrest.registrado_por = userid;

            window.console.log( JSON.stringify(this.inscripcionrest,null,4) )
        },
    },
    mounted(){
        if( sessionStorage.xprograma != undefined ) { // tambien se usa en AexcelInscribirProgramas.vue
            var ob1 = JSON.parse(sessionStorage.xprograma);
            if( !isNullObject(ob1) ) this.programa = ob1;
        }
        if( sessionStorage.xinscripcion != undefined ) {
            var ob = JSON.parse(sessionStorage.xinscripcion);
            if( !isNullObject(ob) ) this.inscripcion = ob;
        }
        if( isNullObject(ob1) ) {
            this.$notify( error( 'Error','No existe el programa seleccionado, vuelva atras y seleccione uno.' ) )
        }
        //window.console.log( window.stringifyObject(this.programa) )
        if( this.programa != null ){
            this.inscripcionrest.programa_id = this.programa.id;

            this.inscripcion.idestudiante = null;
            this.inscripcion.idprograma = this.programa.id;
            this.inscripcion.matricula.monto = this.programa.monto_matricula;
            this.inscripcion.certificacion.monto = this.programa.monto_certificacion;
            this.inscripcion.monto.monto_colegiatura = this.programa.monto_colegiatura;
            this.inscripcion.monto.cuotas = this.programa.cuotas;
            this.inscripcion.monto.fecha_ins = this.programa.fecha_inicio;
            var vue = this;
            setTimeout( function(){
                var ff = vue.programa.fecha_fin;
                var fi = vue.programa.fecha_inicio;
                vue.inscripcion.certificacion.fecha = ff;
                vue.inscripcion.matricula.fecha = fi;
                //window.console.log( "FECHA FINNNNN ",fi,window.stringifyObject(vue.inscripcion) )
            },3000)
        }
        var ats = window.sessionStorage.route_ins;
        if( ats ) this.atras = ats;

        this.lisCuotas();
    
    }
    
}